import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { NotificationService } from '../../services/notification.service';
import { withLatestFrom } from 'rxjs/operators';

import {
  CpplLoad,
  CpplLoadSuccess,
  CpsiLoad,
  CpsiLoadSuccess,
  HandoverDocsActionTypes,
  McplLoad,
  McplLoadSuccess,
  McsiLoad,
  McsiLoadSuccess,
} from '@completion/actions';
import { State } from '@completion/reducers';
import { getCurrentCpId, getCurrentProject } from '@completion/selectors';
import { HandoverDocsService } from '@completion/services';
import { trackResource } from './resource-fetch.util';
import { Cppl, Cpsi, Mcpl, Mcsi } from '@completion/models';

@Injectable()
export class HandoverDocsEffect {
  constructor(
    private actions$: Actions,
    private handoverDocsService: HandoverDocsService,
    private store: Store<State>,
    private toastr: NotificationService,
  ) {}

  loadCppl$ = createEffect(() =>
    this.actions$.pipe(
      ofType<CpplLoad>(HandoverDocsActionTypes.CpplLoad),
      withLatestFrom(this.store.select(getCurrentProject), this.store.select(getCurrentCpId)),
      trackResource<Cppl>({
        actions$: this.actions$,
        store: this.store,
        toastr: this.toastr,
        service: this.handoverDocsService,
        method: 'getCppl',
        serviceArgs: ([action, currentProject, cpId]) => [currentProject.id, cpId, action.handoverId],
        onSuccess: (response) => new CpplLoadSuccess(response),
      }),
    ),
  );

  loadMcpl$ = createEffect(() =>
    this.actions$.pipe(
      ofType<McplLoad>(HandoverDocsActionTypes.McplLoad),
      withLatestFrom(this.store.select(getCurrentProject), this.store.select(getCurrentCpId)),
      trackResource<Mcpl>({
        actions$: this.actions$,
        store: this.store,
        toastr: this.toastr,
        service: this.handoverDocsService,
        method: 'getMcpl',
        serviceArgs: ([action, currentProject, cpId]) => [currentProject.id, cpId, action.handoverId, action.mccId],
        onSuccess: (response) => new McplLoadSuccess(response),
      }),
    ),
  );

  loadMcsi$ = createEffect(() =>
    this.actions$.pipe(
      ofType<McsiLoad>(HandoverDocsActionTypes.McsiLoad),
      withLatestFrom(this.store.select(getCurrentProject), this.store.select(getCurrentCpId)),
      trackResource<Mcsi>({
        actions$: this.actions$,
        store: this.store,
        toastr: this.toastr,
        service: this.handoverDocsService,
        method: 'getMcsi',
        serviceArgs: ([action, currentProject, cpId]) => [currentProject.id, cpId, action.handoverId, action.mccId],
        onSuccess: (response) => new McsiLoadSuccess(response),
      }),
    ),
  );

  loadCpsi$ = createEffect(() =>
    this.actions$.pipe(
      ofType<CpsiLoad>(HandoverDocsActionTypes.CpsiLoad),
      withLatestFrom(this.store.select(getCurrentProject), this.store.select(getCurrentCpId)),
      trackResource<Cpsi>({
        actions$: this.actions$,
        store: this.store,
        toastr: this.toastr,
        service: this.handoverDocsService,
        method: 'getCpsi',
        serviceArgs: ([action, currentProject, cpId]) => [currentProject.id, cpId, action.handoverId],
        onSuccess: (response) => new CpsiLoadSuccess(response),
      }),
    ),
  );
}
